import React from "react"
import { withRouter } from "react-router"
import moment from "moment"
import { Card, Badge, CardBody } from "reactstrap"
import { useQuery } from "@apollo/react-hooks"
import { Spinner } from "components/spinner"
import { withBreadcrumb, useBread } from "components/breadcrumb"
import { announcementTypes, findTypeValueByKey } from "utils/types"

import { GET_ANNOUNCEMENT } from "../../gql"

import "./style/style.scss"

const AnnouncementFormCl = props => {
  const { data, loading } = useQuery(GET_ANNOUNCEMENT, {
    fetchPolicy: "cache-and-network",
    variables: { id: props.match.params.id }
  })

  useBread({ to: props.match.url, name: data?.announcement?.title })

  if (loading) {
    return <Spinner />
  }

  return (
    <Card className="announcement-detail">
      <CardBody>
        <h2 className="mb-3">{data?.announcement?.title}</h2>
        <span className="mr-2">
          <i className="mdi mdi-calendar-text" />{" "}
          {data?.announcement?.startTime &&
            moment(data.announcement.startTime).format("YYYY-MM-DD a h:mm")}
        </span>
        <Badge color="success">
          {findTypeValueByKey(announcementTypes, data?.announcement?.type)}
        </Badge>
        <hr />
        <div className="img-block">
          {data?.announcement?.photoUrl && (
            <img src={`http://${data.announcement.photoUrl}`} />
          )}
        </div>
        <div className="content">{data.announcement.content}</div>
      </CardBody>
    </Card>
  )
}

export default withBreadcrumb(withRouter(AnnouncementFormCl))
